import LogoCreate from "@/views/exhibitor/logo/LogoCreate.vue";
import { ROLES } from "@/config/Roles";
import auth from "@/middlewares/AuthMiddleware";
import i18n from "@/locales";
import LogoView from "@/views/exhibitor/logo/LogoView.vue";
import LogoList from "@/views/exhibitor/logo/LogoList.vue";

export default [
  {
    path: "/logo",
    component: LogoView,
    meta: {
      visibleInAside: true,
      roles: [ROLES.EXHIBITOR],
      title: String(i18n.t("menu.logo")),
      middleware: [auth]
    },
    children: [
      {
        path: "",
        name: "logo",
        component: LogoList,
        meta: {
          visibleInAside: true,
          title: "",
          roles: [ROLES.EXHIBITOR],
          middleware: [auth]
        }
      },
      {
        path: "create",
        name: "logo_create",
        component: LogoCreate,
        meta: {
          visibleInAside: true,
          roles: [ROLES.EXHIBITOR],
          title: String(i18n.t("general.logo_add")),
          middleware: [auth]
        }
      }
    ]
  }
];
